module.exports = (__webpack_require__(25))(2);